





import OlbIcon from '../icon/icon.vue';
import { defineComponent } from '@vue/composition-api';

export default defineComponent({
	components: { OlbIcon },
	props: {
		light: {
			type: Boolean,
			default: false,
			required: false,
		},
	},
	setup() {
		return {};
	},
});
